"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/typeof"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/symbol"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _setTimeout3 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _setInterval3 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = _interopRequireDefault(require("vue"));

var _json = _interopRequireDefault(require("json5"));

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextXhrBackend = _interopRequireDefault(require("i18next-xhr-backend"));

var _vueI18next = _interopRequireDefault(require("@panter/vue-i18next"));

var _vueVirtualScroller = _interopRequireDefault(require("vue-virtual-scroller"));

require("vue-virtual-scroller/dist/vue-virtual-scroller.css");

require("whatwg-fetch");

require("intersection-observer");

var _available = _interopRequireDefault(require("@/res/locales/available.json"));

var _enUs = _interopRequireDefault(require("@/../static/locales/en-us.json"));

var _App = _interopRequireDefault(require("@/components/App"));

var _StartupError = _interopRequireDefault(require("@/components/StartupError"));

var _Logger = _interopRequireDefault(require("@/libs/Logger"));

var _ConfigLoader = _interopRequireDefault(require("@/libs/ConfigLoader"));

var _state = _interopRequireDefault(require("@/libs/state"));

var _ThemeManager = _interopRequireDefault(require("@/libs/ThemeManager"));

var _InputHandler = _interopRequireDefault(require("@/libs/InputHandler"));

var _StatePersistence = _interopRequireDefault(require("@/libs/StatePersistence"));

var Storage = _interopRequireWildcard(require("@/libs/storage/Local"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));

var _AudioManager = require("@/libs/AudioManager");

var _SoundBleep = require("@/libs/SoundBleep");

var _WindowTitle = _interopRequireDefault(require("@/libs/WindowTitle"));

var _configTemplates = require("@/res/configTemplates");

require("@/components/utils/TabbedView");

require("@/components/utils/InputText");

require("@/components/utils/IrcInput");

require("@/components/utils/InputPrompt");

require("@/components/utils/InputConfirm");

require("@/thirdparty/");

// fetch polyfill
// polyfill for vue-virtual-scroller & ie11
// Global utilities
_vue.default.use(_vueVirtualScroller.default);

var logLevelMatch = window.location.href.match(/kiwi-loglevel=(\d)/);

if (logLevelMatch && logLevelMatch[1]) {
  var newLevel = (0, _parseInt2.default)(logLevelMatch[1], 10);

  _Logger.default.setLevel(newLevel);

  (0, _Logger.default)('Logging level set to', newLevel);
}

var log = _Logger.default.namespace('main'); // Add the global API as soon as possible so that things can start listening to it


var api = window.kiwi = _GlobalApi.default.singleton(); // Third party imports now have access to the state and api

/* eslint-disable import/first */


function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');

    if (pair[0] === variable) {
      return pair[1];
    }
  }

  return false;
} // Add a handy this.listen() fn to Vue instances. Saves on the need to add an event listener
// and then manually remove them all the time.


_vue.default.mixin({
  beforeDestroy: function beforeDestroy() {
    var _context;

    (0, _forEach.default)(_context = this.listeningEvents || []).call(_context, function (fn) {
      return fn();
    });
  },
  methods: {
    listen: function listen(source, event, fn) {
      this.listeningEvents = this.listeningEvents || [];

      var off = function off() {
        (source.removeEventListener || source.$off || source.off).call(source, event, fn);
      };

      this.listeningEvents.push(off);
      (source.addEventListener || source.$on || source.on).call(source, event, fn);
      return off;
    },
    listenOnce: function listenOnce(source, event, _fn) {
      var fn = _fn;
      this.listeningEvents = this.listeningEvents || [];

      var off = function off() {
        (source.removeEventListener || source.$off || source.off).call(source, event, fn);
      };

      this.listeningEvents.push(off);

      if (source.addEventListener) {
        // Create our own once handler as the DOM doesn't support this itself
        fn = function onceFn() {
          source.removeEventListener(event, onceFn);
          fn.apply(void 0, arguments);
        };

        source.addEventListener(event, fn);
      } else {
        (source.$once || source.once).call(source, event, fn);
      }

      return off;
    }
  }
}); // Timer functions that are auto cleaned up when a component is destroyed


_vue.default.mixin({
  beforeDestroy: function beforeDestroy() {
    var _context2;

    (0, _forEach.default)(_context2 = this.timerEvents || []).call(_context2, function (tmr) {
      return clearTimeout(tmr);
    });
  },
  methods: {
    setInterval: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      this.timerEvents = this.timerEvents || [];

      var v = _setInterval3.default.apply(void 0, arguments);

      this.timerEvents.push(v);
      return v;
    }),
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      this.timerEvents = this.timerEvents || [];

      var v = _setTimeout3.default.apply(void 0, arguments);

      this.timerEvents.push(v);
      return v;
    })
  }
}); // Make the state available to all components by default


_vue.default.mixin({
  computed: {
    $state: function $state() {
      return (0, _state.default)();
    }
  }
}); // Allow adding existing raw elements to component templates
// Eg: <div v-rawElement="domElement"></div>
// Eg: <div v-rawElement="{el: domElement, data:{foo:'bar'}}"></div>


_vue.default.directive('rawElement', {
  bind: function bind(el, binding) {
    if (binding.value.nodeName) {
      el.appendChild(binding.value);
    } else if (binding.value.el) {
      var rawEl = binding.value.el;
      el.appendChild(rawEl); // Add any data attributes to the raw element

      if (binding.value.data) {
        var _context3;

        (0, _forEach.default)(_context3 = (0, _keys.default)(binding.value.data)).call(_context3, function (key) {
          rawEl.dataset[key] = binding.value.data[key];
        });
      } // Add any properties to the raw element


      if (binding.value.props) {
        var _context4;

        (0, _forEach.default)(_context4 = (0, _keys.default)(binding.value.props)).call(_context4, function (key) {
          rawEl[key] = binding.value.props[key];
        });
      }
    }
  }
}); // Register a global custom directive called `v-focus`


_vue.default.directive('focus', {
  // Support conditional eg. v-focus="false"
  bind: function bind(el, bindings) {
    el.dataset.focus = bindings.value === undefined || !!bindings.value;
  },
  // When the bound element is inserted into the DOM...
  inserted: function inserted(el) {
    // dataset properties are strings
    if (el.dataset.focus !== 'true') {
      return;
    } // Element is input so focus it


    if (el.tagName === 'INPUT') {
      el.focus();
      return;
    } // Try to focus the first input element


    var input = el.getElementsByTagName('input')[0];

    if (input) {
      input.focus();
    }
  }
});

var ROSymbol = (0, _symbol.default)('resizeobserver');

_vue.default.directive('resizeobserver', {
  bind: function bind(el, bindings) {
    var cb = bindings.value || function noop() {};

    el[ROSymbol] = new ResizeObserver(cb);
    el[ROSymbol].observe(el);
  },
  unbind: function unbind(el) {
    el[ROSymbol].unobserve(el);
  }
});

loadApp();

function loadApp() {
  var configFile = 'static/config.json';
  var configObj = null;
  /**
   * Finding the config file
   * In order, looks in the following places:
   *   1. If a 'config' argument is in the query string, static/config_THEVALUE_.json
   *   2. If a window.kiwiConfig function exists, use it's return value as the config object.
   *   3. If a <meta name="kiwiconfig" content=""> is found, then the content becomes the config
   *      URL.
   *   4. If a <script name="kiwiconfig" type="application/json"></script> is found, then the
   *      content becomes the config JSON without making another web request.
   */

  if (getQueryVariable('config')) {
    configFile = 'static/config_' + getQueryVariable('config') + '.json';
  } else if (typeof window.kiwiConfig === 'function') {
    try {
      configObj = window.kiwiConfig();
    } catch (err) {
      log.error('Config file: ' + err.stack);
      showError();
    }
  } else if (document.querySelector('meta[name="kiwiconfig"]')) {
    configFile = document.querySelector('meta[name="kiwiconfig"]').content;
  } else if (document.querySelector('script[name="kiwiconfig"]')) {
    var configContents = document.querySelector('script[name="kiwiconfig"]').innerHTML;

    try {
      configObj = _json.default.parse(configContents);
    } catch (parseErr) {
      log.error('Config file: ' + parseErr.stack);
      showError();
    }
  }

  var configLoader = new _ConfigLoader.default();
  configLoader.addValueReplacement('protocol', window.location.protocol).addValueReplacement('wsprotocol', window.location.protocol === 'https:' ? 'wss:' : 'ws:').addValueReplacement('tls', window.location.protocol === 'https:').addValueReplacement('hostname', window.location.hostname).addValueReplacement('host', window.location.host).addValueReplacement('port', window.location.port || (window.location.protocol === 'https:' ? 443 : 80)).addValueReplacement('hash', (window.location.hash || '').substr(1)).addValueReplacement('query', (window.location.search || '').substr(1)).addValueReplacement('referrer', window.document.referrer);
  (configObj ? configLoader.loadFromObj(configObj) : configLoader.loadFromUrl(configFile)).then(applyConfig).then(initState).then(initInputCommands).then(initLocales).then(initThemes).then(loadPlugins).then(initSound).then(startApp).catch(showError);
}

function applyConfig(config) {
  Misc.dedotObject(config); // if we have a config template apply that before other configs

  if (_configTemplates.configTemplates[config.template]) {
    applyConfigObj(_configTemplates.configTemplates[config.template], (0, _state.default)().settings);
  }

  applyConfigObj(config, (0, _state.default)().settings);
} // Recursively merge an object onto another via Vue.$set


function applyConfigObj(obj, target) {
  _lodash.default.each(obj, function (val, key) {
    if ((0, _typeof2.default)(val) === 'object') {
      if ((0, _typeof2.default)(target[key]) !== 'object') {
        // Create the correct type of object
        var newVal = _lodash.default.isArray(val) ? [] : {};

        _vue.default.set(target, key, newVal);
      }

      applyConfigObj(val, target[key]);
    } else {
      _vue.default.set(target, key, val);
    }
  });
}

function loadPlugins() {
  return new _promise.default(function (resolve, reject) {
    var plugins = (0, _state.default)().settings.plugins || [];
    var pluginIdx = -1;
    loadNextScript();

    function loadNextScript(sSrc, fOnload) {
      var _context5;

      var plugin = plugins[++pluginIdx];

      if (!plugin) {
        resolve();
        return;
      }

      if ((0, _indexOf.default)(_context5 = plugin.url).call(_context5, '.js') > -1) {
        // The plugin is a .js file so inject it as a script
        var scr = document.createElement('script');

        scr.onerror = function () {
          var _context6;

          log.error((0, _concat.default)(_context6 = "Error loading plugin '".concat(plugin.name, "' from '")).call(_context6, plugin.url, "'"));
          loadNextScript();
        };

        scr.onload = function () {
          loadNextScript();
        };

        document.body.appendChild(scr);
        scr.src = plugin.url;
      } else {
        // Treat the plugin as a HTML document and just inject it into the document
        fetch(plugin.url).then(function (response) {
          return response.text();
        }).then(function (pluginRaw) {
          var el = document.createElement('div');
          el.id = 'kiwi_plugin_' + plugin.name.replace(/[ "']/g, '');
          el.style.display = 'none';
          el.innerHTML = pluginRaw; // The browser won't execute any script elements so we need to extract them and
          // place them into the DOM using our own script elements

          var scripts = (0, _toConsumableArray2.default)(el.querySelectorAll('script')); // IE11 does not support nodes.forEach()

          (0, _forEach.default)(scripts).call(scripts, function (limitedScr) {
            limitedScr.parentElement.removeChild(limitedScr);
            var scr = document.createElement('script');
            scr.text = limitedScr.text;
            el.appendChild(scr);
          });
          document.body.appendChild(el);
          loadNextScript();
        }).catch(function () {
          var _context7;

          log.error((0, _concat.default)(_context7 = "Error loading plugin '".concat(plugin.name, "' from '")).call(_context7, plugin.url, "'"));
          loadNextScript();
        });
      }
    }
  });
}

function initLocales() {
  _vue.default.use(_vueI18next.default); // Make the translation services available via the global API


  api.i18n = _i18next.default;

  _i18next.default.use(_i18nextXhrBackend.default);

  _i18next.default.init({
    whitelist: _available.default.locales,
    fallbackLng: 'en-us',
    lowerCaseLng: true,
    backend: {
      loadPath: 'static/locales/{{lng}}.json',
      // allow cross domain requests
      crossDomain: false,
      // allow credentials on cross domain requests
      withCredentials: false
    },
    interpolation: {
      // We let vuejs handle HTML output escaping
      escapeValue: false
    }
  }); // Build in the english translation so it can be used as a fallback


  _i18next.default.addResourceBundle('en-us', 'translation', _enUs.default); // Override the $t function so that empty translations fallback to en-us


  _vue.default.mixin({
    computed: {
      $t: function $t() {
        var _this = this;

        return function (key, options) {
          var val = _this.$i18n.i18next.t(key, options, _this.$i18n.i18nLoadedAt);

          if (!val) {
            var opts = options || {};
            opts.lng = 'en-us';
            val = _this.$i18n.i18next.t(key, opts, _this.$i18n.i18nLoadedAt);
          }

          return val;
        };
      }
    }
  });

  var setDefaultLanguage = function setDefaultLanguage() {
    var defaultLang = (0, _state.default)().setting('language');
    var preferredLangs = _lodash.default.clone(window.navigator && window.navigator.languages) || []; // our configs default lang overrides all others

    if (defaultLang) {
      preferredLangs.unshift(defaultLang);
    } // set a default language


    _i18next.default.changeLanguage('en-us'); // Go through our browser languages until we find one that we support


    for (var idx = 0; idx < preferredLangs.length; idx++) {
      var lang = preferredLangs[idx]; // if this is a language such as 'fr', add a following one of 'fr-fr' to cover
      // both cases

      if (lang.length === 2) {
        (0, _splice.default)(preferredLangs).call(preferredLangs, idx + 1, 0, lang + '-' + lang);
      }

      if ((0, _includes.default)(_lodash.default).call(_lodash.default, _available.default.locales, lang.toLowerCase())) {
        _i18next.default.changeLanguage(lang, function (err, t) {
          if (err) {
            // setting the language failed so set default again
            _i18next.default.changeLanguage('en-us');
          }
        });

        break;
      }
    }
  };

  setDefaultLanguage(); // Update the language if the setting changes.

  (0, _state.default)().$watch('user_settings.language', function (lang) {
    if (!lang && !(0, _state.default)().setting('language')) {
      setDefaultLanguage();
    } else {
      _i18next.default.changeLanguage(lang || (0, _state.default)().setting('language') || 'en-us');
    }
  });
}

function initState() {
  return _initState.apply(this, arguments);
}

function _initState() {
  _initState = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var stateKey, persistLog, persist;
    return _regenerator.default.wrap(function _callee$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            stateKey = (0, _state.default)().settings.startupOptions.state_key; // Default to a preset key if it wasn't set

            if (typeof stateKey === 'undefined') {
              stateKey = 'kiwi-state';
            }

            persistLog = _Logger.default.namespace('StatePersistence');
            persist = new _StatePersistence.default(stateKey || '', (0, _state.default)(), Storage, persistLog);
            persist.includeBuffers = !!(0, _state.default)().settings.startupOptions.remember_buffers;

            if (!stateKey) {
              _context8.next = 8;
              break;
            }

            _context8.next = 8;
            return persist.loadStateIfExists();

          case 8:
            api.setState((0, _state.default)());

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee);
  }));
  return _initState.apply(this, arguments);
}

function initThemes() {
  var themeMgr = _ThemeManager.default.instance((0, _state.default)());

  api.setThemeManager(themeMgr);
  var argTheme = getQueryVariable('theme');

  if (argTheme) {
    themeMgr.setTheme(argTheme);
  }
}

function initSound() {
  var sound = new _SoundBleep.SoundBleep();
  var bleep = new _AudioManager.AudioManager(sound);
  bleep.listen((0, _state.default)());
  bleep.watchForMessages((0, _state.default)());
}

function initInputCommands() {
  /* eslint-disable no-new */
  new _InputHandler.default((0, _state.default)());
}

function startApp() {
  new _WindowTitle.default((0, _state.default)());
  api.emit('init');
  /* eslint-disable no-new */

  new _vue.default({
    el: '#app',
    render: function render(h) {
      return h(_App.default);
    },
    i18n: new _vueI18next.default(_i18next.default)
  });
  api.emit('ready');
}

function showError(err) {
  if (err) {
    log.error('Error starting Kiwi IRC:', err);
  } else {
    log.error('Unknown error starting Kiwi IRC');
  }
  /* eslint-disable no-new */


  new _vue.default({
    el: '#app',
    render: function render(h) {
      return h(_StartupError.default, {
        props: {
          error: err
        }
      });
    }
  });
}